import JapanFlagImage from '@/assets/icons/japan-flag.svg';
import BskdnImage from '@/assets/images/bskdn.png';
import { Card, Flex, Image, Layout, theme } from '@/components';
import type { FC, PropsWithChildren, ReactNode } from 'react';

type Props = {
  cardTitle?: ReactNode;
};

export const AuthenticationPagesLayout: FC<PropsWithChildren<Props>> = ({
  children,
}) => {
  const { token } = theme.useToken();

  return (
    <Layout
      style={{
        height: '100vh',
        display: 'flex',
      }}
    >
      <Layout.Content
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        }}
      >
        <Card
          style={{ width: '50%' }}
          title={
            <Flex justify="center" align="center" gap={8}>
              <Image
                src={BskdnImage}
                fallback={BskdnImage}
                alt="logo image"
                width={100}
                preview={false}
              />
              <Image
                src={JapanFlagImage}
                alt="japan flag"
                width={80}
                preview={false}
                style={{ border: `1px solid ${token.colorBorder}`, margin: 4 }}
              />
            </Flex>
          }
        >
          {children}
        </Card>
      </Layout.Content>
    </Layout>
  );
};
